import { Spinner } from 'flowbite-react'
import { useTranslation } from 'react-i18next'

interface LoadingStateProps {
  message?: string
  showMessage?: boolean
  size?: 'sm' | 'md' | 'lg' | 'xl'
  variant?: 'inline' | 'panel' | 'fullscreen'
  className?: string
}

function buildContainerClass(variant: LoadingStateProps['variant'], className?: string): string {
  const variantClass = variant === 'fullscreen'
    ? 'min-h-screen flex items-center justify-center page-bg'
    : variant === 'inline'
      ? 'flex items-center justify-center'
      : 'flex items-center justify-center py-10'

  return className ? `${variantClass} ${className}` : variantClass
}

export default function LoadingState({
  message,
  showMessage = true,
  size = 'lg',
  variant = 'panel',
  className,
}: LoadingStateProps) {
  const { t } = useTranslation()

  return (
    <div className={buildContainerClass(variant, className)}>
      <div className="flex items-center gap-3">
        <Spinner size={size} />
        {showMessage ? (
          <p className="text-sm text-muted">{message ?? t('common.loading')}</p>
        ) : null}
      </div>
    </div>
  )
}
